import { debounce, templateDetails } from '../utils'

{
    const ignoredTemplates = ['index', 'about', 'article', 'how-to-refill']
    const ignoredTemplatesDesktop = ['list-collections', 'collection']

    const header = document.getElementById('header')
    const main = document.getElementById('main')
    const templateData = templateDetails()
    const hideContentPadding = templateData.some(x => ignoredTemplates.includes(x))
    const hideContentPaddingDesktop = templateData.some(x => ignoredTemplatesDesktop.includes(x))

    const setContentPadding = () => {
        if (hideContentPaddingDesktop && window.innerWidth >= 1024) return

        main.style.paddingTop = `${header.offsetHeight}px`
    }

    const init = () => {
        window.addEventListener('resize', debounce(setContentPadding))
        setContentPadding()
    }

    if (!hideContentPadding) init()
}
